import { combineReducers } from "redux";
import user from './user';
import ficha from './crear/ficha';
import extra from './cargar/extra';
import notificacion from './cargar/notificaciones';
import taxonomia from "./crear/taxonomia";
import galeria from "./crear/galeria";
import paquete from "./crear/paquete";
import explorar from "./general/explorar";
import solicitudes from "./general/solicitudes";
import especie from "./cargar/especie";
import verificacion from "./verificacion/verificacion";
import { reducer as formReducer } from 'redux-form'
import loaderReducer from './loader';
import observacion from "./crear/observacion";
import version from "./crear/version";
import pdf from "./cargar/pdf";
import proyecto from "./crear/proyecto";
import ecosistema from "./general/ecosistema";
import dex from "./crear/dex";
import medalla from "./crear/medallas";
import usuariosDexPanel from "./dex/usuariosDexPanel";
import especiedex from "./dex/especiedex";
import rankingdex from "./dex/rankingdex";

export default combineReducers({
    form : formReducer,
    medalla: medalla,
    dex:dex,
    ecosistema:ecosistema,
    loader: loaderReducer,
    rankingdex,
    usuariosDexPanel,
    especiedex,
    proyecto: proyecto,
    observacion: observacion,
    version: version,
    galeria: galeria,
    especie:especie,
    pdf: pdf,
    user,
    ficha,
    extra,
    taxonomia,
    notificacion,
    paquete,
    explorar,
    solicitudes,
    verificacion,
});